module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-tablet-738x100.c8ddcd38.jpg";